export default "__VITE_ASSET__vfPUXtss__"